define('models/reseller_manager',['require','backbone','models/phone_number'],function(require){

    var Backbone = require('backbone');

    var PhoneNumberModel = require('models/phone_number');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'reseller-managers/' + this.id + '/' ) :
                ( App.Config.apiBase + 'reseller-managers/' );
        },

        defaults: function () {
            return {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: new PhoneNumberModel().attributes,
                phone_country: 0,
                phone_value: ''
            };
        }
    });
});
